<template>
  <div
    class="button-group"
  >
    <!-- Warning message -->
    <transition>
      <div
        v-show="checkInput"
        class="notification is-warning"
      >
        <font-awesome-icon
          icon="exclamation-triangle"
          class="is-medium has-text-black"
        />
          {{ $t('common.check_inputs') }}
      </div>
    </transition>

    <!-- Error message -->
    <transition>
      <div
        v-show="failedSave"
        class="notification is-danger"
      >
        <font-awesome-icon
          icon="exclamation-triangle"
          class="is-medium has-text-white"
        />
        {{ $t('common.try_again') }}
      </div>
    </transition>

    <!-- Success message -->
    <transition>
      <div
        v-show="successSave"
        class="notification is-success"
      >
        <font-awesome-icon
          icon="check-circle"
          class="is-medium has-text-white"
        />
        {{ $t('common.info_edited_ok') }}
      </div>
    </transition>

    <button
      id="cancel-btn"
      class="button is-primary is-large is-broad is-uppercase"
      :disabled="disabled"
      @click="$emit('cancel')"
    >
      {{ $t('common.cancel') }}
    </button>
    <button
      id="save-btn"
      class="button is-primary is-large is-broad is-uppercase"
      :disabled="disabled"
      @click="$emit('save')"
    >
      {{ $t('common.save') }}
    </button>
  </div>
</template>

<script>
import { SECONDS_IN_MS } from '@/helpers'

export default {

  name: 'ButtonGroup',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    showCancelBtn: {
      type: Boolean,
      default: false
    },
    showSaveBtn: {
      type: Boolean,
      default: false
    },
    checkInput: {
      type: Boolean,
      default: false
    },
    successSave: {
      type: Boolean,
      default: false
    },
    failedSave: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.v-enter-active, .v-leave-active {
  transition: opacity .5s
}

.v-enter, .v-leave-to {
  opacity: 0
}

.button-group {
  padding: 20px;
  float: right;

  #save-btn {
    margin-left: 5px;
  }
}

@media only screen and (max-width: $break-small) {
  .button-group {
    padding: 20px 0;
  }
}
</style>
